<script setup>
import { nextTick, watch } from "vue";
import { useArticleBase } from "../hooks/useArticleBase";
import PlayVideo from "./PlayVideo.vue";
import Slide from "./SlideBtn.vue";
import Pager from "./Pager.vue";

const { length, idx, article } = useArticleBase("movie");

watch(idx, async () => {
    await nextTick(); // DOM更新が終わるのを待つ
    const contents = document.querySelector(".l-section.-movie .l-section__inner");

    contents.setAttribute("data-change", 0);
    void contents.offsetWidth; // Reflowを強制する

    setTimeout(() => {
        contents.setAttribute("data-change", 1);
    }, 100);
});
</script>

<template>
    <PlayVideo :id="article.fields.id" :classNames="['movie__thumb']"></PlayVideo>
    <div class="movie__detail">
        <p class="movie__title" v-html="article.fields.append_title"></p>
        <div class="movie__arrows" v-if="length > 1">
            <Slide v-model="idx" :length="length"></Slide>
        </div>
    </div>
    <div class="movie__pager" v-if="length > 1">
        <Pager v-model="idx" :length="length"></Pager>
    </div>
</template>
